import { AppContext } from '../../context';
import Card from '../../components/Card';
import React, { useContext } from 'react';

import './styles.scss';

const InvalidLink: React.FC = () => {
    const { translate } = useContext(AppContext);

    return (
        <div className="container">
            <Card
                cardTextHeader={translate('expired:invalidLink')}
                cardTextMessage={translate('expired:interviewHasExpired')}
                isError
            />
        </div>
    );
};

export default InvalidLink;
